module.exports = __webpack_public_path__ + "static/media/instagram.debec23a.svg";